export interface ICoordinador {
  usuario?: string;
  cvu?: string;
  nombre?: string;
  fechaAlta?: string;
  activo?: boolean;
  correo?: string;
}

export class Coordinador implements ICoordinador {
  constructor(
    public usuario?: string,
    public cvu?: string,
    public nombre?: string,
    public fechaAlta?: string,
    public activo?: boolean,
    public correo?: string
  ) {
    this.cvu = cvu;
    this.correo = correo;
  }
}

export interface ICoordinadorExtendido extends ICoordinador {
  telefono?: string;
  correoInstitucional?: string;
  correoAlterno?: string;
}

export class CoordinadorExtendido extends Coordinador implements ICoordinadorExtendido {
  constructor(
    public usuario?: string,
    public cvu?: string,
    public nombre?: string,
    public fechaAlta?: string,
    public activo?: boolean,
    public correo?: string,
    public telefono?: string,
    public correoInstitucional?: string,
    public correoAlterno?: string
  ) {
    super(usuario, cvu, nombre, fechaAlta, activo, correo);
    this.telefono = telefono;
    this.correoInstitucional = correoInstitucional;
    this.correoAlterno = correoAlterno;
  }
}
